// Component: historyFetchWindow.js
// Purpose: Pure history-window calculation shared by chart and order loading.

import moment from 'moment-timezone';

//--> One authority for the padded window used by full fetches, pages, and orders.
export const historyFetchWindow = ({ mode, timeframe, fetchDateRange = null, dateRange = null }) => {
    const resolvedFetchRange = fetchDateRange || dateRange;
    const useHistoricPath =
        mode === 'backtest' ||
        ((mode === 'rd' || mode === 'live' || mode === 'paper') && resolvedFetchRange?.start);

    if (useHistoricPath) {
        if (!resolvedFetchRange?.start) return null;
        const isIntraday = timeframe !== '1D' && timeframe !== '1h';
        const paddingDays = (mode === 'backtest' || mode === 'rd')
            ? (fetchDateRange?.start || !isIntraday ? 180 : 30)
            : 30;
        return {
            startDate: moment.utc(resolvedFetchRange.start).subtract(timeframe === '1D' ? 365 : paddingDays, 'days'),
            endDate: resolvedFetchRange.end ? moment.utc(resolvedFetchRange.end) : moment.utc(),
        };
    }

    return {
        startDate: moment().subtract(timeframe === '1D' ? 30 : 5, 'days'),
        endDate: moment(),
    };
};
